import { render } from "./inputUrlCopy.vue?vue&type=template&id=01370c54&scoped=true"
import script from "./inputUrlCopy.vue?vue&type=script&lang=js"
export * from "./inputUrlCopy.vue?vue&type=script&lang=js"

import "./inputUrlCopy.vue?vue&type=style&index=0&id=01370c54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01370c54"]])

export default __exports__